import React from 'react'

const TrueEPIntro = ({ styles }) => {
  return (
    <section className={styles.hero}>
      <div className={styles.heroBox}>
        <h1 className={styles.heroTitle}>trueEP</h1>
      </div>
    </section>
  )
}

export default TrueEPIntro